<button class="btn btn-primary" id="sidebarToggle" (click)="toggle()"><i class="fa-thin fa-bars"></i></button>